import React from 'react';
import { connect } from 'react-redux';
import { Button, Label, Input, FormText, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import 'react-dropdown/style.css'
import info from "../../config/messages";

const validate = values => {

    const errors = {};
    if (!values.given_name) {
        errors.given_name = info.Validations.User.fname;
    }
    if (!values.family_name) {
        errors.family_name = info.Validations.User.lname;
    }
    if (!values.email) {
        errors.email = info.Validations.User.email;
    } else {
        var regexEmail = new RegExp("^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$");
        if (!regexEmail.test(values.email)) {
            errors.email = info.Validations.User.emailval;;
        }
    }

    return errors;
}

const renderField = ({
    input,
    label,
    type,
    icon,
    options,
    meta: { touched, error, warning }
}) => {
    return (
        <FormGroup className="mb-3">
            <Label>{label}</Label>
            {
                type !== "select" ?
                    <Input {...input} type={type} placeholder={label} />
                    :
                    <Input {...input} type={type} placeholder={label}>
                        <option value="">Select...</option>
                        {options.map(option => (
                            <option value={option.value} key={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </Input>
            }
            {touched && ((error && <FormText color="danger">{error}</FormText>))}
        </FormGroup>
    );
}

let UpdateOwnProfile = props => {
    const { handleSubmit, submitting } = props
    return (
        <form onSubmit={handleSubmit}>
            <Field component={renderField} type="text" label="First Name" name="given_name" />
            <Field component={renderField} type="text" label="Last Name" name="family_name" />
            <Field component={renderField} type="text" label="Phone Number" name="phone_number" />
            <Field component={renderField} type="text" label="Email" name="email" />
            <Button color="primary" disabled={submitting} type="submit">Update</Button>
        </form>
    );
}

function mapStateToProps(state, ownProps, context) {

    const { data } = ownProps;
    return { initialValues: data }
}

let UpdateUserProfileData = reduxForm({
    validate: validate,
    form: 'createUser',
    enableReinitialize: true
})(UpdateOwnProfile);
export default connect(state => (mapStateToProps), {})(UpdateUserProfileData);



// WEBPACK FOOTER //
// ./src/containers/forms/UpdateOwnProfile.js